import { all, put, select } from 'redux-saga/effects';

import { getLoketLeaveBalance } from '../../helpers/api-ts/leaveBalance';
import getLoketEmployeeIdsFromAbsences from '../../services/AbsenceLegacyService/getLoketEmployeeIdsFromAbsences';
import mapLoketLeaveBalancesToLeaveOfAbsences
    from '../../services/LeaveOfAbsenceLegacyService/mapLoketLeaveBalancesToLeaveOfAbsences';
import {
    ABSENCES_GET_LOA_LEAVE_BALANCES_FAILURE,
    ABSENCES_GET_LOA_LEAVE_BALANCES_REQUEST,
    ABSENCES_GET_LOA_LEAVE_BALANCES_SUCCESS,
} from '../actionTypes';

export function* getAndApplyLeaveOfAbsenceLoketLeaveBalances() {
    yield put({ type: ABSENCES_GET_LOA_LEAVE_BALANCES_REQUEST });

    try {
        // @ts-ignore
        const state = yield select();
        const { openLeaveOfAbsencesRequests } = state.absencesReducer;
        const loketEmployeeIds = getLoketEmployeeIdsFromAbsences(openLeaveOfAbsencesRequests);
        // @ts-ignore
        const employeeLeaveBalances = yield all(loketEmployeeIds
            .map(loketEmployeeId => getLoketLeaveBalance(loketEmployeeId)));
        const leaveOfAbsences = mapLoketLeaveBalancesToLeaveOfAbsences(openLeaveOfAbsencesRequests, employeeLeaveBalances);

        yield put({
            type: ABSENCES_GET_LOA_LEAVE_BALANCES_SUCCESS,
            leaveOfAbsencesRequests: leaveOfAbsences,
        });
    } catch (error) {
        yield put({ type: ABSENCES_GET_LOA_LEAVE_BALANCES_FAILURE });
    }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export default function* absencesWatcher() {}
